import { combineReducers } from 'redux';
import home from './home';
import about from './about';
import catalogReducer from './catalog';
import dashboard from './dashboard';
import finance from './finance';
import anticheat from './anticheat';
import anticheatDebugger from './anticheatDebugger';
import guard from './guard';
import campaignAttribution from './campaignAttribution';

const reduxState = combineReducers({
  catalogReducer,
  home,
  about,
  dashboard,
  finance,
  anticheat,
  anticheatDebugger,
  guard,
  campaignAttribution,
});

export default reduxState;
